module.exports = __webpack_public_path__ + "static/media/aggregates-on-sand-desktop.94021aad.jpg";